import calculationReducer, { CALCULATION_CREATE, CALCULATION_REMOVE, CALCULATION_UPDATE, CALCULATION_PATCH, CALCULATION_PATCH_SECTION, CALCULATION_LAYER_POSITION, CALCULATION_RENAME, CALCULATION_ADD_SECTION, CALCULATION_REMOVE_SECTION, CALCULATION_UPDATE_RESULTS, CALCULATION_CALCULATE_RESULTS, CALCULATION_ADD_ADAPTER, CALCULATION_REMOVE_ADAPTER, CALCULATION_PATCH_ADAPTER } from './calculation';

// Actions
const PREFIX = 'calculus/project/';

export const PROJECT_PATCH  = PREFIX + 'PROJECT_PATCH';
export const PROJECT_SELECT  = PREFIX + 'PROJECT_SELECT';
export const PROJECT_SAVE  = PREFIX + 'PROJECT_SAVE';

export const PROJECT_DETAILS_OPEN  = PREFIX + 'PROJECT_DETAILS_OPEN';
export const PROJECT_DETAILS_CLOSE  = PREFIX + 'PROJECT_DETAILS_CLOSE';

export const CREATE_NEW_PROJECT_OPEN  = PREFIX + 'CREATE_NEW_PROJECT_OPEN';
export const CREATE_NEW_PROJECT_CLOSE  = PREFIX + 'CREATE_NEW_PROJECT_CLOSE';
export const VALIDATE_PROJECT  = PREFIX + 'VALIDATE_PROJECT';


export const INITIAL_STATE = {
  unsaved: false,
  loaded: true,
  title: 'Project',
  calculationIndex: -1,
  clientName: '',
  reference: '',
  address: '',
  notes: '',
  useMarineProducts: false,
  calculations: []
};

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload, initialized } = action;

  switch (type) {
    case PROJECT_SELECT:

      let items = {
        ...payload
      };

      if(items && !items.calculations) {
        items.calculations = [];
        items.calculationIndex = -1;
      }

      if(items && items.calculations && items.calculations.length > 0) {
        items.calculationIndex = 0;
      }

      return items;

    case PROJECT_PATCH:
      return {
        ...state,
        ...payload,
      };

    case VALIDATE_PROJECT:
      if(!payload) return state;
      return {
        ...state,
        ...payload,
      };

    case CALCULATION_CREATE:
      return {
        ...state,
        unsaved: initialized ? true : false,
        calculations: [
          ...state.calculations,
          payload
        ],
        calculationIndex: state.calculations.length
      };

    case CALCULATION_REMOVE:

      const calculationRemoveIndex = payload ? payload.index : state.calculationIndex;

      let calculations = [
        ...state.calculations.slice(0, calculationRemoveIndex),
        ...state.calculations.slice(calculationRemoveIndex + 1)
      ];

      let calculationIndex = -1;
      if(calculations[calculationRemoveIndex]) {
        calculationIndex = calculationRemoveIndex;
      } else if(calculations[calculationRemoveIndex - 1]) {
        calculationIndex = calculationRemoveIndex - 1;
      }

      return {
        ...state,
        unsaved: true,
        calculations: calculations,
        calculationIndex: calculationIndex
      };

    case CALCULATION_UPDATE:
    case CALCULATION_PATCH:
    case CALCULATION_PATCH_SECTION:
    case CALCULATION_RENAME:
    case CALCULATION_ADD_ADAPTER:
    case CALCULATION_REMOVE_ADAPTER:
    case CALCULATION_PATCH_ADAPTER:
      return {
        ...state,
        unsaved: true,
        calculations: state.calculations.map((item, index) => {
            if(index !== state.calculationIndex) {
                // This isn't the item we care about - keep it as-is
                return item;
            }
            // Otherwise, this is the one we want - return an updated value
            return calculationReducer( item, action );
        })
      };

    case CALCULATION_LAYER_POSITION:
      return {
        ...state,
        calculations: state.calculations.map((item, index) => {
            if(index !== state.calculationIndex) {
                // This isn't the item we care about - keep it as-is
                return item;
            }
            // Otherwise, this is the one we want - return an updated value
            return calculationReducer( item, action );
        })
      };
    case CALCULATION_ADD_SECTION:
      return {
        ...state,
        unsaved: true,
        calculations: state.calculations.map((item, index) => {
            if(index !== state.calculationIndex) {
                // This isn't the item we care about - keep it as-is
                return item;
            }
            // Otherwise, this is the one we want - return an updated value
            return calculationReducer( item, action );
        })
      };

    case CALCULATION_REMOVE_SECTION:
      return {
        ...state,
        unsaved: true,
        calculations: state.calculations.map((item, index) => {
            if(index !== state.calculationIndex) {
                // This isn't the item we care about - keep it as-is
                return item;
            }
            // Otherwise, this is the one we want - return an updated value
            return calculationReducer( item, action );
        })
      };

      case CALCULATION_UPDATE_RESULTS:
        return {
          ...state,
          calculations: state.calculations.map((item, index) => {
              if(index !== state.calculationIndex) {
                  // This isn't the item we care about - keep it as-is
                  return item;
              }
              // Otherwise, this is the one we want - return an updated value
              return calculationReducer( item, action );
          })
        };

      case CALCULATION_CALCULATE_RESULTS:
        return {
          ...state,
          calculations: state.calculations.map((item, index) => {
              if(index !== state.calculationIndex) {
                  // This isn't the item we care about - keep it as-is
                  return item;
              }
              // Otherwise, this is the one we want - return an updated value
              return calculationReducer( item, action );
          })
        };

      case CALCULATION_RENAME:
        return {
          ...state,
          unsaved: true,
          calculations: state.calculations.map((item, index) => {
              if(index !== state.calculationIndex) {
                  // This isn't the item we care about - keep it as-is
                  return item;
              }
              // Otherwise, this is the one we want - return an updated value
              return calculationReducer( item, action );
          })
        };

    default:
      return state;
  }
}

// Action Creators
export function saveProject(payload) {
  return {
    type: PROJECT_SAVE,
    payload: payload
  };
}

export function patchProject(payload) {
  return {
    type: PROJECT_PATCH,
    payload: payload
  };
}

export function selectProject(payload) {
  return {
    type: PROJECT_SELECT,
    payload: payload
  };
}

export function openProjectDetails() {
  return {
    type: PROJECT_DETAILS_OPEN
  };
}

export function closeProjectDetails() {
  return {
    type: PROJECT_DETAILS_CLOSE
  };
}

export function openCreateNewProjectDialog() {
  return {
    type: CREATE_NEW_PROJECT_OPEN
  };
}

export function closeCreateNewProjectDialog() {
  return {
    type: CREATE_NEW_PROJECT_CLOSE
  };
}

export function validateProject(payload) {
  return {
    type: VALIDATE_PROJECT,
    payload: payload
  };
}
